module.exports = __webpack_public_path__ + "img/introducePageFive_show_five.88f25f34.jpg";